import { gql } from "@apollo/client";
import ACCOUNT_QUERY from "./accountQuery";
import CONFIG_QUERY from "./configQuery";
import REPORT_QUERY from "./reportQuery";
import USER_QUERY from "./userQuery";

const QUERY = {
	//Auth

	//Users
	USERS: USER_QUERY,

	//Report
	REPORTS: REPORT_QUERY,

	//Account
	ACCOUNT: ACCOUNT_QUERY,

	//Config
	CONFIG: CONFIG_QUERY,
};
export default QUERY;
